import { alpha, Theme } from '@mui/material/styles';

export const getPrimaryButtonStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.desert.main,
  color: theme.palette.taiga.main,
  '&:hover': {
    backgroundColor: theme.palette.desertTint.main,
  },
  '&:focus-visible': {
    outline: 'none',
    backgroundColor: theme.palette.desertTint.main,
    boxShadow: `0 0 0 4px ${alpha(theme.palette.desertTint.main, 0.24)}`,
  },
  '&[aria-disabled="true"], &.Mui-disabled': {
    backgroundColor: alpha(theme.palette.desert.main, 0.3),
    color: theme.palette.taigaTint1.main,
  },
});

export const getSecondaryButtonStyles = (theme: Theme) => ({
  backgroundColor: 'transparent',
  border: `2px solid ${theme.palette.desert.main}`,
  '&:hover': {
    backgroundColor: theme.palette.desertTint.main,
    borderColor: theme.palette.desertTint.main,
    backgroundSize: 'unset',
  },
  '&:focus-visible': {
    outline: 'none',
    backgroundColor: theme.palette.desertTint.main,
    boxShadow: `0 0 0 4px ${alpha(theme.palette.desertTint.main, 0.24)}`,
    backgroundSize: 'unset',
  },
  '&[aria-disabled="true"], &.Mui-disabled': {
    color: theme.palette.taigaTint1.main,
    borderColor: `${theme.palette.desertTint.main}4D`,
    cursor: 'not-allowed',
    opacity: 0.3,
    pointerEvents: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: `${theme.palette.desertTint.main}4D`,
    },
    '&:focus-visible': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
});
